/* ==========================================================================
   Storytellers · Set düzeni davranışları (yedek tema)
   Favoriler, mobil beden paneli, filtre hapları, ana sayfa listeleri,
   ürün kaydırıcı ve "Birlikte giy" sepete ekleme.
   ========================================================================== */
(function () {
  'use strict';

  var STR = window.stSetStrings || {};
  var KEY = 'st-wishlist';

  /* ---------- Favoriler ---------- */
  function readWish() {
    try {
      var v = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && /^[a-z0-9-]+$/.test(h); }) : [];
    } catch (e) { return []; }
  }
  function writeWish(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, 60))); } catch (e) { /* özel pencere */ }
  }
  function syncWish() {
    var list = readWish();
    document.querySelectorAll('[data-st-wish]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-st-wish')) > -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = on ? btn.getAttribute('data-label-remove') : btn.getAttribute('data-label-add');
      if (label) btn.setAttribute('aria-label', label);
    });
    document.querySelectorAll('[data-st-wish-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-st-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-st-wish');
    var list = readWish();
    var i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); } else { list.unshift(handle); }
    writeWish(list);
    syncWish();
    if (document.querySelector('[data-st-wishpage]') && i > -1) {
      var li = btn.closest('li');
      if (li && li.parentElement && li.parentElement.matches('[data-st-wish-grid]')) { li.remove(); updateWishPage(); }
    }
  });

  function rootUrl() {
    var r = (window.theme && theme.routes && theme.routes.root_url) || '/';
    return r.replace(/\/+$/, '');
  }

  function updateWishPage() {
    var page = document.querySelector('[data-st-wishpage]');
    if (!page) return;
    var grid = page.querySelector('[data-st-wish-grid]');
    var empty = page.querySelector('[data-st-wish-empty]');
    var count = grid.children.length;
    empty.hidden = count > 0;
  }

  function renderWishPage() {
    var page = document.querySelector('[data-st-wishpage]');
    if (!page) return;
    var grid = page.querySelector('[data-st-wish-grid]');
    var list = readWish();
    if (!list.length) { updateWishPage(); return; }
    var base = rootUrl();
    Promise.all(list.map(function (handle) {
      return fetch(base + '/products/' + handle + '?section_id=st-set-card', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (htmls) {
      var keep = [];
      htmls.forEach(function (html, idx) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('product-card');
        if (!card) return;
        var li = document.createElement('li');
        li.className = 'column';
        li.appendChild(document.importNode(card, true));
        grid.appendChild(li);
        keep.push(list[idx]);
      });
      if (keep.length !== list.length) writeWish(keep);
      syncWish();
      updateWishPage();
      if (window.lazySizes) grid.querySelectorAll('.lazyload').forEach(function (img) { window.lazySizes.loader.unveil(img); });
    });
  }

  /* ---------- Mobil beden paneli ---------- */
  var sheet, sheetSizes, sheetTitle, sheetView, lastTrigger;
  function buildSheet() {
    if (sheet) return;
    sheet = document.createElement('div');
    sheet.className = 'st-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-labelledby', 'st-sheet-title');
    sheet.innerHTML =
      '<div class="st-sheet__backdrop" data-st-sheet-close></div>' +
      '<div class="st-sheet__panel">' +
        '<div class="st-sheet__head"><div><p class="st-sheet__title" id="st-sheet-title"></p><p class="st-sheet__sub"></p></div>' +
        '<button type="button" class="st-sheet__close" data-st-sheet-close aria-label=""><svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M2 2l10 10M12 2 2 12" stroke="currentColor" stroke-width="1.5"/></svg></button></div>' +
        '<div class="st-sheet__sizes" role="group"></div>' +
        '<a class="st-sheet__view" href="#"></a>' +
      '</div>';
    document.body.appendChild(sheet);
    sheetSizes = sheet.querySelector('.st-sheet__sizes');
    sheetTitle = sheet.querySelector('.st-sheet__title');
    sheetView = sheet.querySelector('.st-sheet__view');
    sheet.querySelector('.st-sheet__sub').textContent = STR.sheetTitle || '';
    sheet.querySelector('.st-sheet__close').setAttribute('aria-label', STR.close || 'Close');
    sheetView.textContent = STR.sheetView || '';
    sheet.addEventListener('click', function (e) { if (e.target.closest('[data-st-sheet-close]')) closeSheet(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet(); });
  }
  function openSheet(card, trigger) {
    buildSheet();
    lastTrigger = trigger;
    var sizes = card.querySelectorAll('.product-card-sizes--size');
    sheetTitle.textContent = trigger.getAttribute('data-title') || '';
    sheetView.href = trigger.getAttribute('data-url') || '#';
    sheetSizes.innerHTML = '';
    sizes.forEach(function (orig) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'st-sheet__size';
      b.textContent = orig.querySelector('span') ? orig.querySelector('span').textContent : orig.textContent;
      if (orig.classList.contains('is-disabled')) b.disabled = true;
      b.addEventListener('click', function () {
        if (b.disabled) return;
        b.classList.add('is-loading');
        orig.click();
        setTimeout(closeSheet, 250);
      });
      sheetSizes.appendChild(b);
    });
    sheet.classList.add('is-open');
    document.body.classList.add('st-sheet-open');
    requestAnimationFrame(function () {
      sheet.classList.add('is-visible');
      var first = sheetSizes.querySelector('button:not(:disabled)') || sheet.querySelector('.st-sheet__close');
      if (first) first.focus();
    });
  }
  function closeSheet() {
    if (!sheet) return;
    sheet.classList.remove('is-visible');
    document.body.classList.remove('st-sheet-open');
    setTimeout(function () { sheet.classList.remove('is-open'); }, 260);
    if (lastTrigger) { try { lastTrigger.focus(); } catch (e) {} }
  }
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-st-plus]');
    if (!trigger) return;
    e.preventDefault();
    var card = trigger.closest('product-card');
    if (card) openSheet(card, trigger);
  });

  /* ---------- Filtre hapları: paneli ilgili filtreye kaydır ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('facets-toggle[data-st-facet]');
    if (!t) return;
    var idx = t.getAttribute('data-st-facet');
    setTimeout(function () {
      var drawer = document.getElementById('Facet-Drawer');
      if (!drawer) return;
      var row = drawer.querySelector('collapsible-row[data-index="' + idx + '"]');
      if (!row) return;
      var det = row.querySelector('details');
      if (det) det.open = true;
      var content = drawer.querySelector('.side-panel-content') || drawer;
      var top = row.getBoundingClientRect().top - content.getBoundingClientRect().top + content.scrollTop - 8;
      content.scrollTo({ top: top, behavior: 'smooth' });
      var summary = row.querySelector('summary');
      if (summary) summary.focus({ preventScroll: true });
    }, 380);
  });

  /* ---------- Koleksiyon listesi: üzerine gelince görsel ---------- */
  function initCats(root) {
    var links = root.querySelectorAll('[data-st-cat]');
    var imgs = root.querySelectorAll('[data-st-cat-img]');
    function activate(i) {
      links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('data-st-cat') === i); });
      imgs.forEach(function (im) { im.classList.toggle('is-active', im.getAttribute('data-st-cat-img') === i); });
    }
    links.forEach(function (l) {
      l.addEventListener('mouseenter', function () { activate(l.getAttribute('data-st-cat')); });
      l.addEventListener('focus', function () { activate(l.getAttribute('data-st-cat')); });
    });
  }

  /* ---------- Ürün kaydırıcı ---------- */
  function initRail(rail) {
    var track = rail.querySelector('[data-st-rail-track]');
    var prev = rail.querySelector('[data-st-rail-prev]');
    var next = rail.querySelector('[data-st-rail-next]');
    var out = rail.querySelector('[data-st-rail-index]');
    if (!track) return;
    function step() { var s = track.querySelector('.st-split__slide'); return s ? s.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : track.clientWidth; }
    function update() {
      var w = step();
      var i = Math.round(track.scrollLeft / Math.max(w, 1));
      var n = track.children.length;
      if (out) out.textContent = Math.min(i + 1, n);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Birlikte giy / sepete ekle ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-st-wear-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('.st-wear__add');
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var data = new FormData(form);
    var base = rootUrl();
    fetch(base + '/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data, credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { console.warn(res.body && res.body.description); return; }
        var done = btn.querySelector('.st-wear__add-done');
        var label = btn.querySelector('.st-wear__add-label');
        btn.classList.add('is-done');
        if (done && label) { done.hidden = false; label.hidden = true; setTimeout(function () { done.hidden = true; label.hidden = false; btn.classList.remove('is-done'); }, 2200); }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        var drawer = document.getElementById('Cart-Drawer');
        if (drawer && typeof OverlayManager !== 'undefined') {
          setTimeout(function () { OverlayManager.open(drawer); if (typeof dispatchCustomEvent === 'function') dispatchCustomEvent('cart-drawer:open'); }, 350);
        }
      })
      .catch(function (err) { console.warn(err); })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });

  /* ---------- Ürün açıklaması: kısa göster, devamını oku ---------- */
  function initPdesc(box) {
    if (box.dataset.stReady) return;
    box.dataset.stReady = '1';
    var body = box.querySelector('.st-pdesc__body');
    var btn = box.querySelector('.st-pdesc__more');
    if (!body || !btn) return;
    /* Kısaltılmış metin satırın ortasından kesilmesin: yüksekliği son tam satıra oturt */
    function snap() {
      body.style.maxHeight = '';
      if (box.classList.contains('is-open')) return;
      var limit = body.clientHeight;
      if (body.scrollHeight <= limit + 4) return;
      var top = body.getBoundingClientRect().top;
      var range = document.createRange();
      range.selectNodeContents(body);
      var rects = range.getClientRects();
      var best = 0;
      for (var i = 0; i < rects.length; i++) {
        var r = rects[i];
        var b = r.bottom - top;
        if (r.height > 0 && r.height < 60 && b <= limit + 1 && b > best) best = b;
      }
      if (best > 0) body.style.maxHeight = Math.ceil(best) + 'px';
    }
    function check() {
      if (box.classList.contains('is-open')) return;
      snap();
      var long = body.scrollHeight > body.clientHeight + 4;
      btn.hidden = !long;
      box.classList.toggle('is-clamped', long);
    }
    btn.addEventListener('click', function () {
      var open = !box.classList.contains('is-open');
      box.classList.toggle('is-open', open);
      box.classList.toggle('is-clamped', !open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? btn.dataset.less : btn.dataset.more;
      if (open) { body.style.maxHeight = ''; } else { snap(); }
    });
    check();
    window.addEventListener('resize', check);
    window.addEventListener('load', check);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
  }

  /* ---------- Başlat ---------- */
  function init() {
    syncWish();
    renderWishPage();
    document.querySelectorAll('[data-st-cats]').forEach(initCats);
    document.querySelectorAll('[data-st-rail]').forEach(initRail);
    document.querySelectorAll('[data-st-pdesc]').forEach(initPdesc);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }

  /* Filtre ve sonsuz kaydırma kartları yeniden çizdiğinde kalpleri eşitle */
  var mo = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      if (records[i].addedNodes.length) { syncWish(); break; }
    }
  });
  function observe() {
    var grid = document.getElementById('ProductGridContainer') || document.getElementById('main-content');
    if (grid) mo.observe(grid, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', observe); } else { observe(); }
  document.addEventListener('shopify:section:load', init);
})();
